export default function WebBuilderFeatures() {
    return (
        <section className="relative w-full pt-20 pb-4 lg:pt-32 lg:pb-12">
            <div className="container">
                <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16">
                    {/* Left side - Heading */}
                    <div className="lg:col-span-3">
                        <h2 className="text-3xl lg:text-4xl font-bold text-white leading-tight">
                            Build, manage, and grow online
                        </h2>
                    </div>

                    {/* Right side - Features grid */}
                    <div className="lg:col-span-9">
                        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-12 lg:gap-6">
                            {/* Feature 1 */}
                            <div className="space-y-3">
                                <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-gradient-to-r from-purple-600/20 to-blue-600/20 border border-purple-500/30">
                                    <svg className="w-7 h-7 text-purple-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 18h.01M8 21h8a2 2 0 002-2V5a2 2 0 00-2-2H8a2 2 0 00-2 2v14a2 2 0 002 2z" />
                                    </svg>
                                </div>
                                <h3 className="text-white font-semibold text-lg">
                                    Responsive on every device
                                </h3>
                                <p className="text-gray-300 text-sm leading-relaxed">
                                    Your website looks great on mobile, tablet, and desktop screens.
                                </p>
                            </div>

                            {/* Feature 2 */}
                            <div className="space-y-3">
                                <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-gradient-to-r from-purple-600/20 to-blue-600/20 border border-purple-500/30">
                                    <svg className="w-7 h-7 text-purple-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
                                    </svg>
                                </div>
                                <h3 className="text-white font-semibold text-lg">
                                    Insights & analytics panel
                                </h3>
                                <p className="text-gray-300 text-sm leading-relaxed">
                                    Monitor visitors, engagement, and growth from one simple dashboard.
                                </p>
                            </div>

                            {/* Feature 3 */}
                            <div className="space-y-3">
                                <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-gradient-to-r from-purple-600/20 to-blue-600/20 border border-purple-500/30">
                                    <svg className="w-7 h-7 text-purple-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                                    </svg>
                                </div>
                                <h3 className="text-white font-semibold text-lg">
                                    Domain-based business email
                                </h3>
                                <p className="text-gray-300 text-sm leading-relaxed">
                                    Create a professional email address using your own domain name.
                                </p>
                            </div>

                            {/* Feature 4 */}
                            <div className="space-y-3">
                                <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-gradient-to-r from-purple-600/20 to-blue-600/20 border border-purple-500/30">
                                    <svg className="w-7 h-7 text-purple-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                                    </svg>
                                </div>
                                <h3 className="text-white font-semibold text-lg">
                                    Dedicated customer assistance
                                </h3>
                                <p className="text-gray-300 text-sm leading-relaxed">
                                    Get reliable help from our support team whenever you need it.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}
